var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Line 2 Copy"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":3},React.createElement("g",{"id":"Image-References","transform":"translate(-293.000000, -67.000000)","stroke":"#000000"},React.createElement("g",{"id":"Group-3","transform":"translate(294.000000, 60.000000)"},React.createElement("g",{"id":"Group-4"},React.createElement("path",{"d":"M0,8 L16,8","id":"Line-2-Copy"})))))]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"18px","height":"2px","viewBox":"0 0 18 2","version":"1.1"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js?name=Icon!./client/assets/icons/filter-close.svg
// module id = 885
// module chunks = 0